<template>
  <div>
    <div
      v-if="FeedbackStatus != 'workflow'"
      @click="navigateFeedbackPage()"
      class="back-arrow-image text-right mt-n3 mr-2"
    ><span style="font-size: 20px;color: #0843a8;">Back</span>
      <img class="back-arrow-icon" src="@/assets/images/right-arrow.svg" />
    </div>
    <div class="card m-4">
      <h4 class="text-left text-heading ml-2 mt-2">Grievance Details</h4>
      <div class="row ml-3" v-if="FeedbackStatus != 'workflow'">
        <div class="col-2 p-0 m-0 text-subheading mt-2">
          <p class="text-left ml-2">Job Code</p>
          <p class="text-left ml-2">Job Name</p>
          <p v-if="poNumber && poNumber !='General'" class="text-left ml-2">{{jobType}} Number</p>
          <p v-if="poNumber && poNumber !='General'" class="text-left ml-2">{{jobType}} Date</p>
        </div>
        <div class="col p-0 m-0 mt-2 text-subheading-value">
          <p class="text-left">{{jobCode}}</p>
          <p class="text-left">{{jobDesc}}</p>
          <p v-if="poNumber && poNumber !='General'" class="text-left">{{poNumber}}</p>
          <p v-if="poNumber && poNumber !='General'" class="text-left">{{dataFormat(poOrderDate)}}</p>
        </div>
      </div>
      <div class="row ml-3" v-else>
        <div class="col-2 p-0 m-0 text-subheading mt-2">
          <p class="text-left ml-2">Job Code</p>
          <p class="text-left ml-2">Job Name</p>
          <p v-if="workflowOrderNumber && workflowOrderNumber !='General'" class="text-left ml-2">{{workflowjobType}} Number</p>
          <p v-if="workflowOrderNumber && workflowOrderNumber !='General'" class="text-left ml-2">{{workflowjobType}} Date</p>
        </div>
        <div class="col p-0 m-0 mt-2 text-subheading-value">
          <p class="text-left">{{workflowJobCode}}</p>
          <p class="text-left">{{jobDesc}}</p>
          <p v-if="workflowOrderNumber && workflowOrderNumber !='General'" class="text-left">{{workflowOrderNumber}}</p>
          <p v-if="workflowOrderNumber && workflowOrderNumber !='General'" class="text-left">{{dataFormat(poOrderDate)}}</p>
        </div>
      </div>
      <hr />
      <h4 class="text-left text-heading ml-2 mt-2">
        Details of Feedback Provider
        <span class="ml-1 subTitleClass">(Mandatory)</span>
      </h4>
      <div class="row m-0 px-5 py-3">
        <div class="col-3">
          <w-text-input
            class="text-input-feild"
            :labelName="$t('Name')"
            @textInputChange="getPartnerName($event)"
            validation="required"
            :defaultValue="form.name"
            :allowOnlyCharacters="true"
            :maxCharacter="'100'"
            :disabled="viewEvaluation"
          />
        </div>
        <div class="col-3">
          <w-text-input
            class="text-input-feild"
            :labelName="$t('Designation')"
            @textInputChange="getDesignation($event)"
            validation="required"
            :defaultValue="form.designation"
            :allowOnlyCharacters="true"
            :maxCharacter="'100'"
            :disabled="viewEvaluation"
          />
        </div>
        <div class="col-3">
          <w-text-input
            class="text-input-feild"
            :labelName="$t('Email')"
            @textInputChange="getEmailId($event)"
            :validation="'required|email'"
            :defaultValue="form.email"
            :maxCharacter="'100'"
            :disabled="viewEvaluation"
          />
        </div>
        <div class="col-3">
          <w-text-input
            class="text-input-feild"
            :labelName="$t('Mobile Number')"
            @textInputChange="getMobileNumber($event)"
            :validation="'required|regex_mobile_number|max:10|min:10'"
            :defaultValue="form.mobileNumber"
            :inputAdditions="'mobile'"
            :type="'number'"
            :maxDigits="'10'"
            :disabled="viewEvaluation"
          />
        </div>
      </div>
    </div>
    <h4 v-if="checkStatus()" class="text-left text-heading ml-5 mt-2">
      Please rate your experience on the following
      <span
        class="ml-1 subTitleClass"
      >(All questions are Mandatory)</span>
    </h4>
    <h4 class="text-left text-heading ml-5 mt-2" v-else>Partner Feedback</h4>
    <div class="mt-4">
      <v-expansion-panel class="mb-2" v-model="panel">
        <v-expansion-panel-content
          v-for="(data,i) in getEvaluationData"
          :key="i"
          expand-icon="mdi-menu-down"
        >
          <template class="expansion-background" v-slot:header>
            <div v-if="panel == i">
              <img class="mr-4" src="@/assets/images/downArrow.svg" />
              {{data.moduleLongDesc}}
              <v-progress-circular
                v-if="FeedbackStatus == 'workflow' && i !=3"
                class="float-right"
                :rotate="360"
                :size="50"
                :width="6"
                :value="data.rating"
                :color="ratingUpdates(data.rating)"
              >{{data.rating}}</v-progress-circular>
            </div>
            <div v-else>
              <img class="mr-4" src="@/assets/images/upArrow.svg" />
              {{data.moduleLongDesc}}
              <v-progress-circular
                v-if="FeedbackStatus == 'workflow' && i !=3"
                class="float-right"
                :rotate="360"
                :size="50"
                :width="6"
                :value="data.rating"
                :color="ratingUpdates(data.rating)"
              >{{data.rating}}</v-progress-circular>
            </div>
          </template>
          <v-card>
            <div
              v-for="(question,qi) in data.question"
              :key="qi"
              style="border-bottom:2px black;"
              class="mt-2"
            >
              <span v-if="checkStatus()">
                <h4 class="pl-5 m-0 p-0 question-text">
                  <span
                    v-if="question.questionCode == question.parentQuestionCode"
                  >{{question.questionNumber}} )</span>
                  <span class="dottedBlack ml-2 mr-3" v-else></span>
                  {{question.question}}
                </h4>

                <span v-for="(answer, answerIndex) in question.answer" :key="answerIndex">
                  <span v-if="answer.controlType == 'M'" class="row mt-2 mb-2 ml-5">
                    <span class="col">
                      <w-text-area
                        :subTitle="'Optional'"
                        :subTitleClass="'sub-title-optional'"
                        :title="'Please specify if there any concerns'"
                        :defaultValue="getTextSelectedValue(answer,question,data,answerIndex)"
                        :validation="''"
                        :rows="'5'"
                        :lablelName="'Remarks'"
                        @inputChanges="getTextAreaInputValue($event,answer,question,data)"
                        :maxTextLength="250"
                        :disabled="viewEvaluation"
                      />
                    </span>
                    <span class="col"></span>
                  </span>
                  <span
                    class="row ml-5 mt-1 mb-2"
                    v-if="answer.controlType === 'R' && answerIndex == 0"
                  >
                    <w-radio
                      class="ml-4"
                      :radioLabel="''"
                      :formRadio="getRadioOptions(question.answer)"
                      @radioInputChange="getRadioInputValue($event,question,data)"
                      :defaultValue="getRadioSelectedValue(answer,question,data)"
                      :disabled="viewEvaluation"
                    />
                  </span>
                  <span
                    class="mx-5 row card card-additional-background"
                    v-if="(getRadioSelectedkeyCode(answer,question,data) == answer.keyCode) && (answer.questionSpecificAnswers && answer.questionSpecificAnswers.displayName != null)"
                  >
                    <h4
                      class="ml-2 mt-1 m-0 p-0 question-additional-text"
                      v-html="answer.questionSpecificAnswers.displayName"
                    >
                      <span v-if="answer.questionSpecificAnswers.mandatory == 'Y'">*</span>
                    </h4>

                    <span
                      v-if="answer.questionSpecificAnswersResponses && answer.questionSpecificAnswersResponses.length > 0"
                    >
                      <span v-if="getRadioSelectedkeyCode(answer,question,data) == answer.keyCode">
                        <span
                          v-for="(additionalAnswer, additionalAnswerIndex) in answer.questionSpecificAnswersResponses"
                          :key="additionalAnswerIndex"
                        >
                          <span
                            class="ml-5 mt-1 mb-2"
                            v-if="additionalAnswer.controlType === 'R' && additionalAnswerIndex == 0"
                          >
                            <span class="row ml-2">
                              <w-radio
                                :disabled="viewEvaluation"
                                class="ml-4"
                                :radioLabel="''"
                                :additionalResponse="true"
                                :formRadio="getRadioOptions(answer.questionSpecificAnswersResponses)"
                                @radioInputChange="getRadioInputofAdditional($event,answer.questionSpecificAnswers,data)"
                                :defaultValue="getRadioSelectedValue(additionalAnswer,answer.questionSpecificAnswers,data)"
                              />
                            </span>
                          </span>
                        </span>
                        <span class="row">
                          <span
                            v-for="(additionalAnswer, additionalAnswerIndex) in answer.questionSpecificAnswersResponses"
                            :key="additionalAnswerIndex"
                            class="col ml-2 mr-2"
                          >
                            <span class="ml-2" v-if="additionalAnswer.controlType === 'T'">
                              <w-customtext-input
                                :disabled="viewEvaluation"
                                :labelName="additionalAnswer.keyDesc"
                                :inputId="additionalAnswer.keyCode"
                                :inputPlaceholder="''"
                                :errorMessage="additionalAnswer.keyDesc"
                                :validation="fieldValidation(additionalAnswer.regax)"
                                :defaultValue="getTextSelectedValue(additionalAnswer,answer.questionSpecificAnswers,data,additionalAnswerIndex)"
                                class="margin-bottom custom-field-size"
                                @textInputChange="getTextAreaInputValue($event,additionalAnswer,answer.questionSpecificAnswers,data)"
                                :inputType="'text'"
                              />
                            </span>
                          </span>
                        </span>
                      </span>
                    </span>
                  </span>
                </span>
              </span>
              <span v-else>
                <div class="row">
                  <div class="col-8">
                    <h4 class="pl-5 m-0 p-0 question-text">
                      <span
                        v-if="question.questionCode == question.parentQuestionCode"
                      >{{question.questionNumber}})</span>
                      <span class="dottedBlack ml-2 mr-3" v-else></span>
                      {{question.question}}
                    </h4>
                  </div>
                  <div class="col-4">
                    <p
                      class="font-bold question-answer"
                      v-if="question.savedAnswer && question.savedAnswer.length > 0"
                    >
                      <span v-for="(data, i) in question.savedAnswer" :key="i">
                        <span class="mb-1" v-if="i == 0 && data.controlType == 'R'">{{data.keyDesc}}</span>
                        <span
                          class="ml-3 question-additional-answer"
                          v-if="i && i == 1 && data.controlType == 'M'"
                          v-b-popover.hover.bottomleft="data.keyDesc"
                        >(View Remarks)</span>
                        <p
                          class="question-answer-add"
                          v-if="i != 0  && data.controlType == 'R'"
                        >{{data.keyDesc}}</p>
                        <p
                          class="p-0 m-0 mb-1 question-answer-add"
                          v-if="i != 0 && data.controlType == 'T'"
                        >
                          {{data.displayName}} :
                          <span class="ml-3">{{data.keyDesc}}</span>
                        </p>
                      </span>
                    </p>
                    <p v-else class="font-bold question-answer">-</p>
                  </div>
                </div>
                <!-- <div class="row ml-3">
                  <p
                    class="font-bold"
                    v-if="question.savedAnswer && question.savedAnswer.length > 1"
                  >
                    <span v-for="(data, i) in question.savedAnswer" :key="i">
                      <span
                        class="ml-5 mr-3"
                        v-if="i != 0 && data.controlType == 'T'"
                      >{{data.keyDesc}}</span>
                    </span>
                  </p>
                </div>-->
              </span>
              <hr v-if="qi <  data.question.length - 1" />
            </div>
          </v-card>
        </v-expansion-panel-content>
      </v-expansion-panel>
      <div class="float-right mt-3 mb-4" v-if="checkStatus()">
        <b-button class="draft-button mr-5" @click="submitFeedbackAsDraft()">
          <img alt src="@/assets/book-mark.svg" />
          Save as Draft
        </b-button>
        <b-button @click="submitFeedbackEvaluation()" class="submit-button mr-3">Submit Feedback</b-button>
      </div>
    </div>
    <w-loadingSpinner :loadSpinner="loading" />
    <!-- <w-radio :radioLabel="'test'" :formRadio="radioInput" /> -->
    <w-modal
      :trigger="triggerModal"
      :text="lastResponse"
      :extraMessage="messageResponse"
      :title="modalTitle"
      :centered="true"
      :dontCloseWhenClickedOutside="true"
      :dontCloseWhenEscapePressed="true"
      :dontShowCloseIcon="true"
      :modalbuttonStyle="true"
      :showAlert="alertModal"
      :showSuccess="successModal"
      @eventClose="changeModalSuccess()"
    />
  </div>
</template>

<script>
import Radio from "../../widgets/Feedbackradio";
import Textarea from "../../widgets/FeedbackTextarea.vue";
import CustomTextInput from "../../widgets/CustomTextInput";
import textInput from "../../widgets/TextInput";
import widgetModal from "../../widgets/newModalWidget";
import loadingSpinner from "../../widgets/LoadingSpinner";
import moment from "moment";
import { PartnerService } from "../../services/partnerService";
const partnerService = new PartnerService();

export default {
  props: [
    "poNumber",
    "vendorCode",
    "jobCode",
    "companyCode",
    "jobType",
    "FeedbackStatus",
    "documentNumber"
  ],

  components: {
    "w-text-area": Textarea,
    "w-radio": Radio,
    "w-customtext-input": CustomTextInput,
    "w-text-input": textInput,
    "w-modal": widgetModal,
    "w-loadingSpinner": loadingSpinner
  },
  created() {
    if (this.FeedbackStatus == "New") {
      this.getPartnerFeedback();
    } else if (this.FeedbackStatus == "History") {
      this.getPartnerHistoryDetails();
      this.viewEvaluation = true;
    } else if (this.FeedbackStatus == "workflow") {
      this.getWorkFlowHistoryDetails();
      this.viewEvaluation = true;
    } else {
      this.getPartnerDraftDetails();
    }
  },

  data() {
    return {
      loading: false,
      module: "financial",
      financialData: "",
      financialValue: [],
      financialStrength: "",
      financialOthers: "",
      financialmerge: "",
      getEvaluationData: [],
      modulesArray: [],
      panel: 0,
      FeedbackStatus: "",
      viewEvaluation: false,
      triggerModal: false,
      lastResponse: "",
      messageResponse: "",
      workflowOrderNumber:"",
      workflowjobType:"",
      alertModal: false,
      successModal: false,
      jobDesc: "",
      poOrderDate: "",
      workflowJobCode: "",
      form: {
        companyCode: 1,
        designation: null,
        documentNumber: "",
        email: null,
        jobCode: "",
        mobileNumber: null,
        name: null,
        orderNumber: "",
        orderType: "",
        partnerNumber: "",
        dynamicQuestionControlResponse: {
          modules: []
        }
      }
    };
  },
  methods: {
    getPartnerName(event) {
      this.form.name = event;
    },
    getDesignation(event) {
      this.form.designation = event;
    },
    getEmailId(event) {
      this.form.email = event;
    },
    getMobileNumber(event) {
      this.form.mobileNumber = event;
    },
    getRadioOptions(answers) {
      let radioOptions = [];
      answers.forEach(element => {
        if (element.controlType == "R") {
          radioOptions.push(element);
        }
      });
      return radioOptions;
    },
    dataFormat(date) {
      return moment(date).format("DD MMM YYYY");
    },
    checkStatus() {
      if (
        this.FeedbackStatus == "workflow" ||
        this.FeedbackStatus == "History"
      ) {
        return false;
      } else {
        return true;
      }
    },
    fieldValidation(questionType) {
      let regularExp = "";
      switch (questionType) {
        case "M":
          regularExp = "required|regex_mobile_number";
          break;
        case "E":
          regularExp = "required|email";
          break;
        case "A":
          regularExp = "required|regex_alpha_special";
          break;
        case "AC":
          regularExp = "required|regex_alphacaps";
          break;
        case "AS":
          regularExp = "required|alpha_spaces";
          break;
        case "N":
          regularExp = "required|regex_number";
          break;
        case "N33":
          regularExp = "required|regex_numless33";
          break;
        case "AN":
          regularExp = "required|regex_alpha_numeric_space";
          break;
        case "P":
          regularExp = "required|regex_percentage";
          break;
        case "PD":
          regularExp = "required|regex_percentage_decimal";
          break;
        case "ASC":
          regularExp = "required|regex_alpha_special";
          break;
        case "UCY":
          regularExp = "required|regex_year";
          break;
        case "PN":
          regularExp = "required|regex_negnumber";
          break;
        case "ANS":
          regularExp = "required|regex_alpha_numeric_special";
          break;
        default:
          regularExp = "required|regex_alpha_numeric_special";
      }
      return regularExp;
    },
    jobSpec(code, name) {
      if (name == "name") {
        var name = code.split("~");
        return name[1];
      } else {
        var name = code.split("~");
        return name[0];
      }
    },
    getRadioInputValue(selectedObj, questionObj, moduleObj) {
      this.setQuestionAnswer(
        selectedObj.keyDesc,
        selectedObj,
        questionObj,
        moduleObj
      );
      this.modulesArray.forEach(element => {
        if (element.moduleCode == moduleObj.moduleCode) {
          element.question.forEach(qes => {
            if (qes.questionCode == questionObj.questionCode) {
              qes.answer = qes.answer.filter(e => {
                return e.answerCode === selectedObj.answerCode;
              });
            }
          });
        }
      });
    },
    getTextAreaInputValue(keyDesc, selectedObj, questionObj, moduleObj) {
      this.setQuestionAnswer(keyDesc, selectedObj, questionObj, moduleObj);
    },
    getRadioInputofAdditional(selectedObj, questionObj, moduleObj) {
      this.setQuestionAnswer(
        selectedObj.keyDesc,
        selectedObj,
        questionObj,
        moduleObj
      );
    },
    getTextSelectedValue(answerObj, questionObj, moduleObject, answerIndex) {
      console.log(answerObj);
      console.log(questionObj);
      console.log(this.modulesArray);
      let multiTextBox = "";
      this.modulesArray.forEach(element => {
        if (element.moduleCode == moduleObject.moduleCode) {
          element.question.forEach((qes, index) => {
            if (qes.questionCode == questionObj.questionCode) {
              qes.answer.forEach(ans => {
                if (
                  ans.controlType == "M" &&
                  ans.answerCode == answerObj.answerCode
                ) {
                  multiTextBox = ans.keyDesc;
                }

                if (
                  ans.controlType == "T" &&
                  ans.answerCode == answerObj.answerCode &&
                  ans.keyCode == answerObj.keyCode
                ) {
                  console.log(answerIndex);
                  console.log(index);
                  multiTextBox = ans.keyDesc;
                }
              });
            }
          });
        }
      });
      return multiTextBox;
    },
    getRadioSelectedValue(answerObj, questionObj, moduleObject) {
      let radioButtonSelected = "";
      this.modulesArray.forEach(element => {
        if (element.moduleCode == moduleObject.moduleCode) {
          element.question.forEach(qes => {
            if (qes.questionCode == questionObj.questionCode) {
              qes.answer.forEach(ans => {
                if (
                  ans.controlType == "R" &&
                  ans.answerCode == answerObj.answerCode
                ) {
                  radioButtonSelected = ans.keyDesc;
                }
              });
            }
          });
        }
      });
      return radioButtonSelected;
    },
    getRadioSelectedkeyCode(answerObj, questionObj, moduleObject) {
      let radioButtonSelected = "";
      this.modulesArray.forEach(element => {
        if (element.moduleCode == moduleObject.moduleCode) {
          element.question.forEach(qes => {
            if (qes.questionCode == questionObj.questionCode) {
              qes.answer.forEach(ans => {
                if (
                  ans.controlType == "R" &&
                  ans.answerCode == answerObj.answerCode
                ) {
                  radioButtonSelected = ans.keyCode;
                }
              });
            }
          });
        }
      });
      return radioButtonSelected;
    },
    getDefaultTextValue(event) {
      console.log(event);
    },
    getSavedAnswer(answer) {
      // console.log(answer);
      var question = "-";
      if (answer && answer.length > 0) {
        answer.forEach(data => {
          var question = data.keyDesc;
          // return question;
        });
      }
      return question;
    },
    getPartnerFeedback() {
      this.loading = true;
      partnerService
        .getEvaluationForm(
          this.companyCode,
          this.jobCode,
          this.poNumber,
          this.jobType,
          this.vendorCode
        )
        .then(resp => {
          if (resp.response) {
            // console.log(resp.response);
            this.loading = false;
            this.getEvaluationData = resp.response[0].modules;
            this.jobDesc = resp.response[0].jobDesc;
            this.poOrderDate = resp.response[0].orderDate;
          } else {
            this.loading = false;
            this.triggerModal = true;
            this.alertModal = true;
            this.lastResponse = resp.failureMessage;
          }
        });
    },
    getWorkFlowHistoryDetails() {
      this.loading = true;
      partnerService.getWorkflowHistory(1, this.documentNumber).then(resp => {
        if (resp.response) {
          let data = {
            companyCode: resp.response[0].companyCode,
            orderType: resp.response[0].orderTypeCode
          };
          console.log(data);
          console.log("EVENT TRIGGRED");
          this.form.name = resp.response[0].name;
          this.form.email = resp.response[0].email;
          this.form.designation = resp.response[0].designation;
          this.form.mobileNumber = resp.response[0].mobileNumber;
          this.poNumber = resp.response[0].orderNumber;
          this.workflowjobType = resp.response[0].orderType
          this.workflowOrderNumber = resp.response[0].orderNumber;
          this.vendorCode = resp.response[0].partnerNumber;
          this.jobCode = resp.response[0].jobCode;
          this.workflowJobCode = resp.response[0].jobCode;
          this.getEvaluationData = resp.response[0].modules;
          this.jobDesc = resp.response[0].jobDesc;
          this.poOrderDate = resp.response[0].orderDate;
          this.getEvaluationData.forEach((moduleData, index) => {
            moduleData.question.forEach((questionData, i) => {
              if (questionData.savedAnswer) {
                questionData.savedAnswer.forEach((answerData, ai) => {
                  this.setQuestionAnswer(
                    answerData.keyDesc,
                    answerData,
                    questionData,
                    moduleData
                  );
                });
              }
            });
          });
          this.loading = false;
          this.$emit("getuserValue", data);
        }
      });
    },
    getPartnerHistoryDetails() {
      this.loading = true;
      partnerService
        .getFeedbackHistory(
          this.companyCode,
          this.jobCode,
          this.poNumber,
          this.jobType,
          this.vendorCode,
          this.documentNumber
        )
        .then(resp => {
          if (resp.response) {
            this.form.name = resp.response[0].name;
            this.form.email = resp.response[0].email;
            this.form.designation = resp.response[0].designation;
            this.form.mobileNumber = resp.response[0].mobileNumber;

            // var moduleData = resp.response[0].modules;

            // moduleData.forEach((groupmodule, index) => {
            //   groupmodule.question.forEach((question, i) => {
            //     if (question.savedAnswer && question.savedAnswer.length > 0) {
            //       var groupdata = [];
            //       console.log(question);
            //       // groupdata.push(groupmodule);
            //       // groupdata.forEach(ques => {
            //       //   ques.question.push(question);
            //       // });
            //       console.log(groupdata);
            //     }
            //   });
            // });

            this.getEvaluationData = resp.response[0].modules;
            this.jobDesc = resp.response[0].jobDesc;
            this.poOrderDate = resp.response[0].orderDate;
            this.getEvaluationData.forEach((moduleData, index) => {
              moduleData.question.forEach((questionData, i) => {
                if (questionData.savedAnswer) {
                  questionData.savedAnswer.forEach((answerData, ai) => {
                    this.setQuestionAnswer(
                      answerData.keyDesc,
                      answerData,
                      questionData,
                      moduleData
                    );
                  });
                }
              });
            });
            this.loading = false;
          }
        });
    },
    getPartnerDraftDetails() {
      this.loading = true;
      partnerService
        .getDraftDetails(
          this.companyCode,
          this.jobCode,
          this.poNumber,
          this.jobType,
          this.vendorCode,
          this.documentNumber
        )
        .then(resp => {
          if (resp.response) {
            this.form.name = resp.response[0].name;
            this.form.email = resp.response[0].email;
            this.form.designation = resp.response[0].designation;
            this.form.mobileNumber = resp.response[0].mobileNumber;
            this.getEvaluationData = resp.response[0].modules;
            this.jobDesc = resp.response[0].jobDesc;
            this.poOrderDate = resp.response[0].orderDate;
            this.getEvaluationData.forEach((moduleData, index) => {
              moduleData.question.forEach((questionData, i) => {
                if (questionData.savedAnswer) {
                  questionData.savedAnswer.forEach((answerData, ai) => {
                    this.setQuestionAnswer(
                      answerData.keyDesc,
                      answerData,
                      questionData,
                      moduleData
                    );
                  });
                }
              });
            });
            this.loading = false;
          }
        });
    },
    changeModalSuccess() {
      this.triggerModal = false;
      this.alertModal = false;
      if (this.successModal == true) {
        if (this.lastResponse == "Feedback saved in draft successfully") {
          this.successModal = false;
        } else {
          this.successModal = false;
          this.$emit("navigateBack", "New");
        }
      }
    },
    ratingUpdates(rating) {
      if (rating <= 50) {
        return "red";
      } else if (rating >= 75) {
        return "green";
      } else if (rating > 50 && rating < 75) {
        return "orange";
      }
    },
    navigateFeedbackPage() {
      console.log(this.FeedbackStatus);
      this.$emit("navigateBack", this.FeedbackStatus);
    },
    setQuestionAnswer(keyDesc, answerObj, questionObj, moduleObj) {
      console.log("answer", answerObj);
      let _moduleObject = {
        moduleCode: moduleObj.moduleCode,
        moduleDisplayOrder: moduleObj.moduleDisplayOrder,
        moduleLongDesc: moduleObj.moduleLongDesc,
        moduleShortDesc: moduleObj.moduleShortDesc,
        question: []
      };
      let _questionObject = {
        answer: [],
        parentQuestionCode: questionObj.parentQuestionCode,
        question: questionObj.question,
        questionCode: questionObj.questionCode,
        questionLevel: questionObj.questionLevel
      };

      if (
        answerObj.questionSpecificAnswersResponses &&
        answerObj.questionSpecificAnswersResponses.length > 0
      ) {
        var questionLevel = "S";
      } else {
        var questionLevel = "R";
      }

      let _answerObject = {
        answerCode: answerObj.answerCode,
        controlType: answerObj.controlType,
        displayOrder: answerObj.displayOrder,
        keyCode: answerObj.keyCode,
        keyDesc: keyDesc,
        keyValue: answerObj.keyValue,
        answerLevel: questionLevel,
        questionSpecificAnswersResponses: []
      };
      let _moduleIndex = this.modulesArray.findIndex(
        x => x.moduleCode == moduleObj.moduleCode
      );
      if (_moduleIndex != -1) {
        //find if module is already in module array
        this.modulesArray.forEach(moduleObject => {
          if (moduleObject.moduleCode == moduleObj.moduleCode) {
            _moduleObject = moduleObject;
          }
        });
      }
      //find if question is already in questions array of module
      if (_moduleObject.question.length > 0) {
        _moduleObject.question.forEach(question => {
          console.log(question.questionCode);
          console.log(questionObj.questionCode);
          if (question.questionCode == questionObj.questionCode) {
            _questionObject = question;
          }
        });
      }
      if (answerObj.controlType == "R") {
        //answer is already present so push new answer
        if (_questionObject.answer.length > 0) {
          // empty question.answerr array;
          // _questionObject.answer = [];
          let answerRadioIndex = _questionObject.answer.findIndex(
            x =>
              x.controlType === answerObj.controlType &&
              x.answerCode == _answerObject.answerCode
          );
          if (answerRadioIndex != -1) {
            _questionObject.answer.splice(answerRadioIndex, 1);
          }
        }
      } else if (answerObj.controlType == "M") {
        if (_questionObject.answer.length > 0) {
          let answerTextIndex = _questionObject.answer.findIndex(
            x =>
              x.controlType === answerObj.controlType &&
              x.keyCode == answerObj.keyCode
          );
          if (answerTextIndex != -1) {
            _questionObject.answer.splice(answerTextIndex, 1);
          }
        }
      } else if (answerObj.controlType == "T") {
        if (_questionObject.answer.length > 0) {
          let answerTextIndex = _questionObject.answer.findIndex(
            x =>
              x.controlType === answerObj.controlType &&
              x.keyCode == answerObj.keyCode
          );
          if (answerTextIndex != -1) {
            _questionObject.answer.splice(answerTextIndex, 1);
          }
          _questionObject.answer.forEach(ques => {
            if (ques.keyDesc == "") {
              _questionObject.answer.splice(answerTextIndex, 1);
            }
          });
        }
      }
      //add selectedAnswer to question
      _questionObject.answer.push(_answerObject);
      // console.log(_moduleObject);
      //text box question
      let questionIndex = _moduleObject.question.findIndex(
        item => item.questionCode === questionObj.questionCode
      );
      if (questionIndex != -1) {
        _moduleObject.question.splice(questionIndex, 1);
      }
      _moduleObject.question.push(_questionObject);
      // console.log(_moduleObject.question);
      //text box question module
      let moduleIndex = this.modulesArray.findIndex(
        item => item.moduleCode === moduleObj.moduleCode
      );
      if (moduleIndex != -1) {
        this.modulesArray.splice(moduleIndex, 1);
      }
      this.modulesArray.push(_moduleObject);
      console.log(this.modulesArray);
    },
    submitFeedbackEvaluation() {
      // console.log(this.$validator);
      // this.$validator.validateAll();
      // if (!this.errors.any()) {
      //   alert("submit");
      // }

      // let moduleObject = {
      //   moduleCode: 0,
      //   moduleDisplayOrder: 0,
      //   moduleLongDesc: "string",
      //   moduleShortDesc: "string",
      //   question: []
      // };
      // let questionObject = {
      //   answer: [],
      //   parentQuestionCode: 0,
      //   question: "string",
      //   questionCode: 0,
      //   questionLevel: "string"
      // };
      // let answerObject = {
      //   answerCode: 0,
      //   controlType: "string",
      //   displayOrder: 0,
      //   keyCode: 0,
      //   keyDesc: "string",
      //   keyValue: "string"
      // };

      // sample Request

      // var saveData = {
      //   companyCode: 1,
      //   designation: "devloper",
      //   documentNumber: "",
      //   dynamicQuestionControlResponse: {
      //     modules: this.modulesArray
      //   },
      //   email: "test@gmail.com",
      //   jobCode: "JE321654",
      //   mobileNumber: "883832434",
      //   name: "abilesh",
      //   orderNumber: "PO213423423421",
      //   orderType: "PO",
      //   partnerNumber: "088614876124"
      // };
      var questionCodeValue = "";
      var answerCodeValue = "";
      let answerObj = [];
      let questionObject = [];
      this.form.companyCode = this.companyCode;
      this.form.jobCode = this.jobCode;
      this.form.orderNumber = this.poNumber;
      this.form.orderType = this.jobType;
      this.form.partnerNumber = this.vendorCode;
      if (this.documentNumber) {
        this.form.documentNumber = this.documentNumber;
      }
      if (
        this.form.name == null ||
        this.form.email == null ||
        this.form.mobileNumber == null ||
        this.form.designation == null
      ) {
        this.triggerModal = true;
        this.alertModal = true;
        this.lastResponse = "Please fill all details in Feedback Provider";
        return;
      }
      // console.log(this.getEvaluationData);
      this.getEvaluationData.forEach((mandatory, index) => {
        mandatory.question.forEach((checkQuestion, index) => {
          if (checkQuestion.answer) {
            checkQuestion.answer.forEach(option => {
              if (
                option.questionSpecificAnswersResponses &&
                option.questionSpecificAnswersResponses.length > 0
              ) {
                questionObject.push({
                  questionCode: checkQuestion.questionCode,
                  answerCode: option.answerCode,
                  controlType: option.controlType,
                  keyCode: option.keyCode,
                  keyDesc: option.keyDesc,
                  additionalAnswer: option.questionSpecificAnswersResponses
                });
              }
            });
          }
        });
      });

      if (this.modulesArray) {
        this.modulesArray.forEach((data, index) => {
          data.question.forEach((checkQuestion, index) => {
            if (checkQuestion.answer) {
              checkQuestion.answer.forEach(option => {
                answerObj.push({
                  questionCode: checkQuestion.questionCode,
                  answerCode: option.answerCode,
                  controlType: option.controlType,
                  keyCode: option.keyCode,
                  keyDesc: option.keyDesc,
                  additionalAnswer: option.questionSpecificAnswersResponses
                });
              });
            }
          });
        });
      }
      answerObj.forEach(answer => {
        questionObject.forEach(question => {
          if (
            answer.questionCode == question.questionCode &&
            answer.keyCode == question.keyCode
          ) {
            console.log("ANSWER", answer);
            console.log("QUESTION", question);
            console.log("SAME QUESTIONS");
            if (answer.controlType == "T") {
              this.modulesArray.forEach((data, index) => {
                data.question.forEach(additionalAnswer => {
                  if (additionalAnswer.answer) {
                    console.log(question);
                    console.log("Question", question.additionalAnswer.length);
                    console.log("Answer", additionalAnswer.answer.length);
                    questionCodeValue = question.additionalAnswer.length;
                    answerCodeValue = additionalAnswer.answer.length;
                  }
                });
              });
            }
          }
        });
      });
      // console.log(questionCodeValue, "Question");
      // console.log(answerCodeValue, "Answer");
      // if (questionCodeValue + 1 == answerCodeValue) {
      //   this.triggerModal = true;
      //   this.alertModal = true;
      //   this.lastResponse = "Please fill all question";
      // }
      // console.log(this.modulesArray);

      this.form.dynamicQuestionControlResponse.modules = this.modulesArray;
      if (this.modulesArray.length <= 0) {
        this.triggerModal = true;
        this.alertModal = true;
        this.lastResponse = "Please fill all the mandatory question for submit";
        return;
      }
      if (this.errors.items.length > 0) {
        this.errors.items.forEach(element => {
          this.triggerModal = true;
          this.alertModal = true;
          this.lastResponse = element.msg;
        });
        return;
      }
      // this.loading = true;

      partnerService
        .saveDynamicData(this.form)
        .then(resp => {
          if (resp.response) {
            this.loading = true;
            if (
              resp.response.Message &&
              resp.response.Message == "Feedback Submitted Successfully"
            ) {
              this.triggerModal = true;
              this.successModal = true;
              this.loading = false;
              this.lastResponse = resp.response.Message;
              this.messageResponse = resp.response.DocumentNumber;
            } else {
              this.loading = false;
              this.triggerModal = true;
              this.alertModal = true;
              var responseData = resp.response;
              for (let i = 0; i < responseData.length; i++) {
                if (responseData[i].questionCode == null) {
                  if (responseData[i].mandatoryQuestionResponse.length > 0) {
                    for (
                      let j = 0;
                      j < responseData[i].mandatoryQuestionResponse.length;
                      j++
                    ) {
                      if (j == 0) {
                        this.lastResponse = `Please fill "${responseData[i].mandatoryQuestionResponse[j].questionName}" in "${responseData[i].moduleName}"`;
                        return;
                      }
                    }
                  }
                } else {
                  this.lastResponse = `Please Complete "${responseData[i].questionName}" in "${responseData[i].moduleName}"`;
                  return;
                }
              }
            }
          } else {
            this.triggerModal = true;
            this.alertModal = true;
            this.loading = false;
            this.lastResponse = resp.failureMessage;
          }
        })
        .catch(err => {
          this.loading = false;
          this.triggerModal = true;
          this.alertModal = true;
          this.lastResponse = "Something went wrong please try again later..!";
        });
      // partnerService.saveDynamicData(this.form).then(resp => {
      //   this.loading = false;
      //   if (resp.response) {
      //     this.triggerModal = true;
      //     this.successModal = true;
      //     this.lastResponse = resp.response.Message;
      //     this.messageResponse = resp.response.DocumentNumber;
      //   } else {
      //     this.triggerModal = true;
      //     this.alertModal = true;
      //     this.lastResponse = resp.failureMessage;
      //   }
      // });
    },
    submitFeedbackAsDraft() {
      this.form.companyCode = this.companyCode;
      this.form.jobCode = this.jobCode;
      this.form.orderNumber = this.poNumber;
      this.form.orderType = this.jobType;
      this.form.partnerNumber = this.vendorCode;
      if (this.documentNumber) {
        this.form.documentNumber = this.documentNumber;
      }
      if (
        this.form.name == null ||
        this.form.email == null ||
        this.form.mobileNumber == null ||
        this.form.designation == null
      ) {
        this.triggerModal = true;
        this.alertModal = true;
        this.lastResponse = "Please fill all details in Feedback Provider";
        return;
      }

      if (this.errors.items.length > 0) {
        this.errors.items.forEach(element => {
          this.triggerModal = true;
          this.alertModal = true;
          this.lastResponse = element.msg;
        });
        return;
      }

      // if (this.modulesArray.length <= 0) {
      //   this.triggerModal = true;
      //   this.alertModal = true;
      //   this.lastResponse = "Atleast one feedback need to be answered";
      //   return;
      // }
      this.loading = true;
      this.form.dynamicQuestionControlResponse.modules = this.modulesArray;

      partnerService.saveDynamicDataAsDraft(this.form).then(resp => {
        if (resp.response) {
          this.triggerModal = true;
          this.successModal = true;
          this.loading = false;
          this.lastResponse = resp.response.Message;
          this.messageResponse = resp.response.DocumentNumber;
        } else {
          this.triggerModal = true;
          this.alertModal = true;
          this.lastResponse = resp.failureMessage;
        }
      });
    }
  }
};
</script>

<style scoped>
.question-text {
  font-size: 16px;
  font-weight: 500;
  font-family: "Source Sans Pro", sans-serif;
  text-align: left;
  color: #000000;
}
.question-answer {
  font-size: 16px;
  font-weight: 600;
  font-family: "Source Sans Pro", sans-serif;
  text-align: left;
  color: #000000;
}
.question-answer-add {
  font-size: 15px;
  font-weight: 500;
  font-family: "Source Sans Pro", sans-serif;
  text-align: left;
  color: #000000;
}

.question-additional-answer {
  cursor: pointer;
  font-size: 14px;
  font-weight: 600;
  font-family: "Source Sans Pro", sans-serif;
  text-align: left;
  color: #1579ab;
  text-decoration: underline;
}
.text-heading {
  font-size: 18px;
  font-weight: 600;
  font-family: "Source Sans Pro", sans-serif;
  color: #000000;
}
.text-subheading {
  font-size: 15px;
  font-weight: 500;
  font-family: "Source Sans Pro", sans-serif;
  color: #000000;
}
.text-subheading-value {
  font-size: 15px;
  font-weight: 500;
  font-family: "Source Sans Pro", sans-serif;
  color: #000000;
}
.question-additional-text {
  font-size: 15px;
  font-weight: 500;
  font-family: "Source Sans Pro", sans-serif;
  text-align: left;
  color: #000000;
}
.card-additional-background {
  /* width: 774px;
  height: 90px; */
  border-radius: 2px;
  border: solid 1px #c3c3c3;
  background-color: #f8f8f8 !important;
}
.subTitleClass {
  font-family: "Open Sans", sans-serif !important;
  font-size: 14px;
  font-weight: 500;
  font-style: italic;
}
.text-input-feild {
  font-family: "Open Sans", sans-serif !important;
  font-size: 14px;
  font-weight: 500; /* font-style: italic; */
  text-align: left;
}
.cancel-button {
  border: solid 1px #707070;
  background-color: #ffffff;
  font-family: "Open Sans", sans-serif !important;
  color: #484848;
  font-size: 15px;
  font-weight: bold;
  outline: none;
}
.draft-button {
  border: solid 1px #0e5d84;
  background-color: #ffffff;
  font-family: "Open Sans", sans-serif !important;
  color: #0e5d84;
  font-size: 15px;
  font-weight: bold;
  outline: none;
}
.submit-button {
  background-color: #0c5e9d;
  font-family: "Open Sans", sans-serif !important;
  color: #ffffff;
  font-size: 15px;
  font-weight: bold;
  outline: none;
}
.dottedBlack {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background-color: #000;
  float: left;
  margin-top: 6px;
}
.back-arrow-icon {
  /* border: solid 1px #707070; */
  color: black !important;
  font-family: "Open Sans", sans-serif !important;
  margin: 0.5px 0px 0px 3px !important;
  height: 25px !important;
  transform: rotate(180deg);
  width: 20px;
}

.back-arrow-image {
  border-radius: 60%;
  background-color: rgb(255, 255, 255) !important;
  z-index: 5;
  position: fixed;
  top: 78px;
  right: 10px;
  cursor: pointer;
  /* float: right; */
}
</style>
<style>
/* .v-expansion-panel__header {
  background-color: #6192b1 !important;
  line-height: 0 !important;
  margin-bottom: 2% !important;
  color: #ffffff !important;
  font-size: 18px;
  font-family: "Open Sans", sans-serif !important;
  font-weight: 500 !important;
} */
</style>

